import { atom } from 'nanostores';

export class ShowcaseStore {
  $isOpened = atom(false);

  $activeFeature = atom(null);

  opener = null;

  store;

  constructor(store) {
    this.store = store;
  }

  openModal(feature) {
    this.opener = document.activeElement;
    this.store.scrollStore.lock('showcase');
    this.$activeFeature.set(feature);
    this.$isOpened.set(true);
  }

  setActiveFeature(feature) {
    this.$activeFeature.set(feature);
  }

  closeModal(restoreFocus = true) {
    this.$isOpened.set(false);
    this.$activeFeature.set(null);
    this.store.scrollStore.unlock('showcase');
    if (restoreFocus) window.requestAnimationFrame(() => this.opener?.focus?.());
    this.opener = null;
  }
}
